import { render, staticRenderFns } from "./ExamPlagiarismCheck.vue?vue&type=template&id=3af41b32"
import script from "./ExamPlagiarismCheck.vue?vue&type=script&lang=js"
export * from "./ExamPlagiarismCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports